import { render, staticRenderFns } from "./JWL_FacilitatorEdit.vue?vue&type=template&id=48033988&"
import script from "./JWL_FacilitatorEdit.vue?vue&type=script&lang=ts&"
export * from "./JWL_FacilitatorEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports